import { useQuery } from '@tanstack/react-query';
import { useTacticHooks } from '../../providers/TacticHooksProvider';

export const useHasStations = () => {
  const { api } = useTacticHooks();

  const hasStationQuery = useQuery({
    queryKey: ['stations', 'hasStations'],

    queryFn: async () => {
      const res = await api.client.stations.hasStations();
      return res.result;
    }
  });
  const hasStations = !!hasStationQuery.data?.enabled;
  return { hasStations };
};
